import Range, { RangeProps } from './Range/Range'
import Description from './Description'
import { useEffect } from 'react'
import { isNumber } from 'lodash'

type RangeWithLabelAndDescriptionProps = RangeProps & {
  label?: string
  description?: string
  small?: boolean
  toolTipLeftAlign?: boolean
  marker?: [number, number]
  initialize?: number
}

const RangeWithLabelAndDescription: React.FC<RangeWithLabelAndDescriptionProps> = ({
  label,
  description,
  value,
  onChange,
  leftLabel,
  rightLabel,
  hidePercentage = false,
  small = false,
  min,
  max,
  step,
  percentageSuffix,
  customCurrentValueLabel,
  toolTipLeftAlign,
  marker,
  initialize,
}) => {
  useEffect(() => {
    if (isNumber(initialize) && isNaN(value)) {
      onChange(initialize)
    }
  }, [initialize, min, value, onChange])

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-1">
        <div className={`${small ? 'text-gray' : 'text-blue text-md md:text-lg'}`}>{label}</div>
        {!!description && <Description text={description} leftAlign={toolTipLeftAlign} />}
      </div>
      <div>
        <Range
          hidePercentage={hidePercentage}
          value={value}
          leftLabel={leftLabel}
          rightLabel={rightLabel}
          onChange={onChange}
          labelClassName={'text-blue'}
          small={small}
          min={min}
          max={max}
          step={step}
          percentageSuffix={percentageSuffix}
          customCurrentValueLabel={customCurrentValueLabel}
          marker={marker}
        />
      </div>
    </div>
  )
}

export default RangeWithLabelAndDescription
